import React, { useState } from 'react';
import { XIcon, UploadIcon, FileIcon, ImageIcon, TypeIcon, PaletteIcon, LayoutTemplateIcon } from 'lucide-react';
interface UploadAssetModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function UploadAssetModal({
  isOpen,
  onClose
}: UploadAssetModalProps) {
  const [dragActive, setDragActive] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    category: 'Logo',
    tags: '',
    description: ''
  });
  if (!isOpen) return null;
  const handleDrag = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };
  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    // Handle file drop here
  };
  return <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm animate-in fade-in duration-200" onClick={onClose} data-id="element-789">
      <div className="bg-white w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-300" onClick={e => e.stopPropagation()} data-id="element-790">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between bg-gray-50" data-id="element-791">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-792">
            Upload Brand Asset
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-200 rounded-full transition-colors text-gray-500" data-id="element-793">
            <XIcon size={20} data-id="element-794" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6" data-id="element-795">
          {/* Drag & Drop Zone */}
          <div className={`border-2 border-dashed rounded-xl p-8 flex flex-col items-center justify-center text-center transition-colors ${dragActive ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-blue-400 hover:bg-gray-50'}`} onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop} data-id="element-796">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-3 text-blue-600" data-id="element-797">
              <UploadIcon size={24} data-id="element-798" />
            </div>
            <p className="text-sm font-medium text-gray-900" data-id="element-799">
              Click to upload or drag and drop
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-800">
              SVG, PNG, JPG or PDF (max. 10MB)
            </p>
          </div>

          <div className="space-y-4" data-id="element-801">
            <div data-id="element-802">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-803">
                Asset Name
              </label>
              <input type="text" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" placeholder="e.g. Primary Logo Dark" value={formData.name} onChange={e => setFormData({
              ...formData,
              name: e.target.value
            })} data-id="element-804" />
            </div>

            <div data-id="element-805">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-806">
                Category
              </label>
              <div className="grid grid-cols-3 gap-2" data-id="element-807">
                {[{
                id: 'Logo',
                icon: ImageIcon
              }, {
                id: 'Color',
                icon: PaletteIcon
              }, {
                id: 'Typography',
                icon: TypeIcon
              }, {
                id: 'Photography',
                icon: ImageIcon
              }, {
                id: 'Template',
                icon: LayoutTemplateIcon
              }, {
                id: 'Document',
                icon: FileIcon
              }].map(cat => {
                const Icon = cat.icon;
                return <button key={cat.id} onClick={() => setFormData({
                  ...formData,
                  category: cat.id
                })} className={`flex flex-col items-center justify-center p-3 rounded-lg border transition-all ${formData.category === cat.id ? 'border-blue-500 bg-blue-50 text-blue-700' : 'border-gray-200 hover:bg-gray-50 text-gray-600'}`} data-id="element-808">
                      <Icon size={20} className="mb-1" data-id="element-809" />
                      <span className="text-xs font-medium" data-id="element-810">{cat.id}</span>
                    </button>;
              })}
              </div>
            </div>

            <div data-id="element-811">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-812">
                Tags
              </label>
              <input type="text" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" placeholder="e.g. dark, vector, official (comma separated)" value={formData.tags} onChange={e => setFormData({
              ...formData,
              tags: e.target.value
            })} data-id="element-813" />
            </div>

            <div data-id="element-814">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-815">
                Description
              </label>
              <textarea className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none resize-none h-20" placeholder="Add usage notes or details..." value={formData.description} onChange={e => setFormData({
              ...formData,
              description: e.target.value
            })} data-id="element-816" />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 flex justify-end gap-3" data-id="element-817">
          <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-200 rounded-lg transition-colors" data-id="element-818">
            Cancel
          </button>
          <button onClick={onClose} className="px-6 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 shadow-sm transition-all transform active:scale-95" data-id="element-819">
            Upload Asset
          </button>
        </div>
      </div>
    </div>;
}